import { AUTH_DISCONNECTED, USERS_CHANGED_CURRENT } from '../mutation-types';
import { } from '../actions';
import each from 'lodash/each';

const DEFAULT_STATE = {
   current: null
};

const getters = {
   getCurrentUser: state => state.current,
   language:       state => state.current ? state.current.language : ''
};

const actions = {
};

const mutations = {
   [USERS_CHANGED_CURRENT](state, user) {
      state.current = user;
   },
   [AUTH_DISCONNECTED](state) {
      each(DEFAULT_STATE, ( val, key ) => {
         state[key] = val;
      });
   }
};

export default {
   state: { ...DEFAULT_STATE },
   getters,
   actions,
   mutations
};
